import React from 'react'
import ReactDOM from 'react-dom/client'
// A fonte dos componentes do @cutilei/ui, nos pesos que eles usam.
import '@fontsource/baloo-2/400.css'
import '@fontsource/baloo-2/500.css'
import '@fontsource/baloo-2/600.css'
import '@fontsource/baloo-2/700.css'
// Todo o CSS global, o reboot do Bootstrap e o da lib, em camadas (ver o próprio arquivo).
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { initErrorReporting, rootErrorOptions } from './services/errorReporting'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png'
import markerIcon from 'leaflet/dist/images/marker-icon.png'
import markerShadow from 'leaflet/dist/images/marker-shadow.png'

delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow
})

// Antes do render: um erro na propria montagem da arvore precisa ser capturado.
initErrorReporting ()

const root = ReactDOM.createRoot(document.getElementById('root'), rootErrorOptions())
root.render (
  <React.StrictMode>
    <App/>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals ()
